import { DateTime, Settings } from 'luxon'
import FilialDataService from '@/services/api/FilialDataService'

const state = {
  globalFilial: {},
  globalDate: DateTime.local().toFormat('y-MM-dd'),
}

const mutations = {
  setGlobalFilial (state, data) {
    state.globalFilial = data

    Settings.defaultZone = data.timeZone || 'Europe/Moscow'
    console.log('=== SET FILIAL TIMEZONE =====>', data.name, data.timeZone, '>>', DateTime.local().zoneName, DateTime.local().toFormat('HH:mm'), '<======')
  },
}

const getters = {
  getGlobalFilial (state) {
    return state.globalFilial
  },
  onlinePaymentAvailable () {
    return false
  },
}

const actions = {
  async loadGlobalFilialInfo ({ commit, rootGetters, dispatch }) {
    const filialId = rootGetters['branches/getGlobalFilialId']
    console.log('=== LOAD FILIAL INFO =====>', filialId)
    if (filialId) {
      const data = await FilialDataService.getOne(filialId)
      console.log('=== LOAD FILIAL INFO =====>', data)
      commit('setGlobalFilial', data)
      dispatch('indicators/setAggregatorsIntegrationStatus', data?.aggregatorsIntegrationStatus, { root: true })
    } else {
      commit('setGlobalFilial', {})
      dispatch('indicators/setAggregatorsIntegrationStatus', [], { root: true })
    }
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
